export const WinInfoViewGrid = {
	size: 100,
	gap: 0,
	name: 'WinInfoViewGrid',
	padding: {
		left: 5,
		// right: 5,
		portrate: {
			left: 3,
			right: 3
		},
		landscape: {
			left: 5
			// right: 5,
		}
	},
	main: [
		{
			name: 'empty',
			size: 3
		},
		{
			name: 'statusbar12',
			size: 97,
			type: 'PortrateGridController',
			config: {
				name: 'statusbar22',
				size: 100,
				gap: 0,
				align: 'left',
				main: [
					{
						name: 'empty',
						size: 85
					},
					{
						name: 'statusbar32',
						type: 'LandscapeGridController',
						size: 6,
						config: {
							size: 100,
							gap: 0,
							name: 'statusbar42',
							main: [
								// {
								// 	name: 'empty',
								// 	size: 30
								// },
								{
									name: 'COPY',
									size: 100,
									align: 'center',
									height: 40,
									bounds: {
										width: 70,
										height: 20
									}
								}
								// {
								// 	name: 'empty',
								// 	size: 30
								// }
							]
						}
					}
				]
			}
		}
	],
	landscape: [
		{
			name: 'empty',
			size: 3
		},
		{
			name: 'statusbar1200',
			size: 97,
			type: 'PortrateGridController',
			config: {
				name: 'statusbar2200',
				size: 100,
				gap: 0,
				align: 'left',
				main: [
					{
						name: 'empty',
						size: 94
					},
					{
						name: 'statusbar3200',
						type: 'LandscapeGridController',
						size: 6,
						config: {
							size: 100,
							gap: 0,
							name: 'statusbar4200',
							main: [
								// {
								// 	name: 'empty',
								// 	size: 30
								// },
								{
									name: 'COPY',
									size: 100,
									align: 'center',
									height: 40,
									bounds: {
										width: 100,
										height: 15
									}
								}
								// {
								// 	name: 'empty',
								// 	size: 30
								// }
							]
						}
					}
				]
			}
		}
	],
	portrate: [
		{
			name: 'empty',
			size: 50
		},
		{
			name: 'statusbar100',
			type: 'LandscapeGridController',
			size: 6,
			config: {
				size: 100,
				gap: 0,
				maxWidth: 'reel',
				name: 'statusbar602',
				main: [
					// {
					// 	name: 'empty',
					// 	size: 30,
					// 	align: 'left_center'
					// },
					{
						name: 'COPY',
						size: 100,
						align: 'center',
						height: 40,
						bounds: {
							width: 70,
							height: 20
						}
					}
					// {
					// 	name: 'empty',
					// 	size: 30,
					// 	align: 'center'
					// }
				]
			}
		}
	]
};
